export interface PlacePrediction {
  text: string;
  description: string;
  code: string;
}
